/**
 * 全局状态
 */
const userCentered = {
    namespaced: true,
    state: {
        //  登录个人中心资料
        userCenteredInfo: null
    },
    mutations: {
        //  修改个人中心资料
        updateUserCenteredInfo(state, userInfo) {
            state.userCenteredInfo = state.userCenteredInfo
                ? Object.assign(state.userCenteredInfo, userInfo)
                : userInfo;
        }
    }
};
export default userCentered;
